import React, { Fragment } from "react";
import styled from "styled-components";
import { ResponsiveBar } from "@nivo/bar";
import { PathwayDotsLayer } from "./PathwayDotsLayer";
import {
  BarChartFormattedData,
  CarbonPathwayByPortfolio,
} from "../../models/controlPanelDataModel";
import { convertDataToBarChartIngestible } from "../../utils/graphUtils";
import { lightGreyText, graphPaletteV2 } from "../../styles";

const ChartContainer = styled.div`
  height: 320px;
  width: 100%;
  padding: 20px 0px 20px 0px;
`;

export const DecarbonisationPathwayChart: React.FC<
  DecarbonisationPathwayBarsProps
> = ({ decarbonisationPathwayData }) => {
  const data: BarChartFormattedData[] = convertDataToBarChartIngestible(
    decarbonisationPathwayData,
  );
  const maxValue = Math.max(...data.map((d) => d.v));
  return (
    <>
      <ChartContainer>
        <ResponsiveBar
          data={data as any} //eslint-disable-line
          keys={["v"]}
          maxValue={maxValue}
          padding={0.6}
          margin={{
            top: 0,
            right: 40,
            bottom: 20,
            left: 40,
          }}
          indexBy="x"
          enableLabel={false}
          colors={({ index }: { index: number }): string =>
            index === 0 ? graphPaletteV2[0] : graphPaletteV2[2]
          }
          borderRadius={2}
          enableGridY={true}
          //eslint-disable-next-line
          // @ts-ignore
          layers={[
            "grid",
            "axes",
            "bars",
            "markers",
            "legends",
            //eslint-disable-next-line
            // @ts-ignore
            (props): void => <PathwayDotsLayer {...props} data={data} />,
          ]}
          theme={theme}
          axisBottom={{ tickSize: 0 }}
        />
      </ChartContainer>
    </>
  );
};

const theme = {
  axis: {
    ticks: {
      text: {
        fill: lightGreyText,
        fontSize: 10,
        fontFamily: "Apercu",
      },
    },
  },
  grid: {
    line: {
      stroke: "#d3d3d3",
      strokeWidth: 0.5,
      strokeDasharray: "5 6",
    },
  },
};

type DecarbonisationPathwayBarsProps = {
  decarbonisationPathwayData: CarbonPathwayByPortfolio[];
};
